import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
import { BadgeItem } from 'src/common/interfaces';
import { StyledBadgeDescription, StyledBadgeImageContainer, StyledBadgeItemContainer, StyledBadgeTextContainer, StyledBadgeTitle, StyledTickIcon } from 'src/features/badges/components/badge/badge.styles';
interface Props {
  badge: BadgeItem;
  isEarned?: boolean;
  isRedesign?: boolean;
}
export const Badge = ({
  badge,
  isEarned = true,
  isRedesign = false
}: Props) => {
  const isDark = useIsDarkMode();
  return <StyledBadgeItemContainer $isDimmed={isRedesign && !isEarned} data-testid="badge-container" data-sentry-element="StyledBadgeItemContainer" data-sentry-component="Badge" data-sentry-source-file="badge.tsx">
      <StyledBadgeImageContainer $isRedesign={isRedesign} data-sentry-element="StyledBadgeImageContainer" data-sentry-source-file="badge.tsx">
        <img src={`https://assets.tryhackme.com${badge.image}`} alt={badge.description} loading="lazy" />
        {isRedesign && isEarned && <StyledTickIcon icon={faCircleCheck} aria-label="Earned badge" $isDark={isDark} />}
      </StyledBadgeImageContainer>
      <StyledBadgeTextContainer data-sentry-element="StyledBadgeTextContainer" data-sentry-source-file="badge.tsx">
        <StyledBadgeTitle data-sentry-element="StyledBadgeTitle" data-sentry-source-file="badge.tsx">{badge.title}</StyledBadgeTitle>
        <StyledBadgeDescription data-sentry-element="StyledBadgeDescription" data-sentry-source-file="badge.tsx">{badge.description}</StyledBadgeDescription>
      </StyledBadgeTextContainer>
    </StyledBadgeItemContainer>;
};